module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    staticClass: "box-set",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    }
  }, [_c('el-card', {
    attrs: {
      "header": "设置规则名称",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "package_name",
      "rules": {
        required: true,
        message: '促销促销',
        trigger: 'blur'
      }
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "最多30个字"
    },
    model: {
      value: (_vm.form.package_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "package_name", $$v)
      },
      expression: "form.package_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "选择主商品"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-button', {
    staticClass: "el-icon-plus",
    attrs: {
      "type": "primary",
      "size": "mini",
      "round": ""
    },
    on: {
      "click": _vm.relMainClick
    }
  }, [_vm._v("主商品选择\n        ")]), _vm._v(" "), _c('GoodsSelect', {
    attrs: {
      "items-visible": _vm.mainVisible,
      "get-status": _vm.setMainStatus,
      "single": _vm.singleData,
      "rel-items-ids": _vm.relMain,
      "item-type": _vm.form.item_type
    },
    on: {
      "chooseStore": _vm.chooseMainAction,
      "closeStoreDialog": _vm.closeMainDialogAction
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.relMain
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "item_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "item_name",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "width": "90",
            "size": "mini"
          },
          model: {
            value: (scope.row.price),
            callback: function($$v) {
              _vm.$set(scope.row, "price", $$v)
            },
            expression: "scope.row.price"
          }
        })]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "选择适用商品 (最大选择10个商品)",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems,
      "limit": 1,
      "hiddenData": _vm.relMain
    },
    on: {
      "change": _vm.getItems,
      "newPrice": _vm.getNewPrice
    }
  })], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "设置商品组合",
      "shadow": "naver"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "适用会员"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.validGrade),
      callback: function($$v) {
        _vm.validGrade = $$v
      },
      expression: "validGrade"
    }
  }, [_vm._l((_vm.memberGrade), function(grade) {
    return _c('el-checkbox', {
      key: grade.grade_id,
      attrs: {
        "label": grade.grade_id
      }
    }, [_vm._v("\n          " + _vm._s(grade.grade_name) + "\n        ")])
  }), _vm._v(" "), _vm._l((_vm.vipGrade), function(vipdata) {
    return _c('el-checkbox', {
      key: vipdata.lv_type,
      attrs: {
        "label": vipdata.lv_type
      }
    }, [_vm._v("\n          付费" + _vm._s(vipdata.grade_name) + "\n        ")])
  })], 2)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用平台"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.used_platform),
      callback: function($$v) {
        _vm.$set(_vm.form, "used_platform", $$v)
      },
      expression: "form.used_platform"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全场可用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用店铺id"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "请输入内容，正确示范：2156,2145,2333 每个店铺id后要有一个英文格式的逗号，最后一个店铺id后不需要加。"
    },
    model: {
      value: (_vm.form.shopid_str),
      callback: function($$v) {
        _vm.$set(_vm.form, "shopid_str", $$v)
      },
      expression: "form.shopid_str"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "适用店铺标签"
    }
  }, [_vm._l((_vm.form.shop_tags), function(tag) {
    return _c('el-tag', {
      key: tag.tag_id,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag.tag_name) + "\n      ")])
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.selectShopdialog
    }
  }, [_vm._v("添加标签")])], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "range-separator": "至",
      "start-placeholder": "生效时间",
      "end-placeholder": "过期时间",
      "format": "yyyy/MM/dd HH:mm:ss",
      "value-format": "timestamp",
      "default-time": ['00:00:00', '23:59:59']
    },
    model: {
      value: (_vm.activity_date),
      callback: function($$v) {
        _vm.activity_date = $$v
      },
      expression: "activity_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-center"
  }, [(_vm.hasSaveButton) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitActivityAction()
      }
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', [_c('el-dialog', {
    staticStyle: {
      "padding": "20px 10px"
    },
    attrs: {
      "title": "适用店铺",
      "visible": _vm.selectShopVisi,
      "width": "30%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.selectShopVisi = $event
      }
    }
  }, [_c('span', [_vm._v("当前已选中:")]), _vm._v(" "), _vm._l((_vm.form.shop_tags), function(tag) {
    return _c('el-tag', {
      key: tag.tag_id,
      staticStyle: {
        "margin-top": "5px"
      },
      attrs: {
        "closable": "",
        "size": "small",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleCloseTag(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag.tag_name) + "\n      ")])
  }), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.shopTagData
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tag_id",
      "label": "标签id"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "tag_name",
      "label": "标签名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          staticStyle: {
            "color": "#ffffff"
          },
          attrs: {
            "color": scope.row.tag_color,
            "size": "mini"
          }
        }, [_vm._v(_vm._s(scope.row.tag_name))])]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.selectShopVisi = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.selectShopVisi = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-38c0eb2a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38c0eb2a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/package/add.vue
// module id = 2621
// module chunks = 0